export default "__VITE_ASSET__c0c7565b__"